import React from "react";

const Logo = ({dark = false}, props) => {

    return (
        <img
            alt="Logo"
            src={dark ? process.env.PUBLIC_URL + "/static/Alif Terminal Black.png" : process.env.PUBLIC_URL + "/static/Alif Terminal White.png"}
            {...props}
            height={35}
        />
    )
};

export default Logo;
